import axios from 'axios'

import { HttpService } from './http.service'

class VerificationService extends HttpService {
  constructor() {
    super(axios)
  }

  verifyCaptcha(token: string) {
    return this.post<boolean, { token: string }>('verifications/re-captcha', { token })
  }
}

export const verificationService = new VerificationService()

export default VerificationService
